import { render } from "./PrivacyPolicyAgreement.vue?vue&type=template&id=2389a4c8&scoped=true"
import script from "./PrivacyPolicyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyAgreement.vue?vue&type=script&lang=js"

import "./PrivacyPolicyAgreement.vue?vue&type=style&index=0&id=2389a4c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2389a4c8"

export default script